module.exports = __webpack_public_path__ + "1791188489487/images/logo.cb067f8.png";